import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { respondToInvitation } from "./api";
import { toaster } from "@/components/ui/toaster";
import { invalidator } from "@shared/react-query";

interface RespondPayload {
  token: string;
  action: "accept" | "decline";
}

interface Args extends UseMutationOptions<void, Error, RespondPayload> {}

export const useRespondToInvitationMutation = ({
  onSuccess,
  ...args
}: Args = {}) =>
  useMutation<void, Error, RespondPayload>({
    mutationFn: ({ token, action }) => respondToInvitation(token, action),
    onSuccess: (...result) => {
      invalidator().byEntity("invitation");
      invalidator().byEntity("user");
      onSuccess?.(...result);
    },
    onError: (error) => {
      toaster.error({
        title: "Failed to respond to invitation",
        description: error.message,
      });
    },
    ...args,
  });
